import { FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { Grid, GridProps, InputAdornment, SelectChangeEvent } from "@mui/material";
import { Search } from "@mui/icons-material";
import { InputSearching, InputDate, AppSelect } from "@/components/common";
import { AppConstant, LangConstant } from "@/const";
import { useApplicationList, useResponseStatusList } from "@/hooks";
import { InternalResponseFilter } from "../hooks/useIdResponseList";

type ResponseRequestFilterProps = GridProps & {
  filter?: InternalResponseFilter;
  onChangeFilter?: (filter: InternalResponseFilter) => void;
};

const ResponseRequestFilter: FC<ResponseRequestFilterProps> = props => {
  const { filter, onChangeFilter } = props;
  const [filterTable, setFilterTable] = useState<InternalResponseFilter>({
    ...filter,
  });
  const { applicationList } = useApplicationList();
  const { t: getLabel } = useTranslation(LangConstant.NS_REQUEST);

  const reqStatusList = useResponseStatusList();

  const handleChangeFilter = (newFilter: InternalResponseFilter) => {
    setFilterTable(newFilter);
    if (onChangeFilter) {
      onChangeFilter(newFilter);
    }
  };

  const handleChangeApplication = (event: SelectChangeEvent<unknown>) => {
    handleChangeFilter({
      ...filterTable,
      applicationSendUid: String(event.target.value),
    });
  };

  const handleChangeRequestStatus = (event: SelectChangeEvent<unknown>) => {
    handleChangeFilter({
      ...filterTable,
      status: String(event?.target?.value) || undefined,
    });
  };
  const handleChangeSearchValue = (keyword: string) => {
    handleChangeFilter({ ...filterTable, filter: keyword });
  };
  const handleChangeStartDate = (value: Date | null) => {
    handleChangeFilter({ ...filterTable, startDate: value });
  };
  const handleChangeEndDate = (value: Date | null) => {
    handleChangeFilter({ ...filterTable, endDate: value });
  };
  return (
    <Grid container spacing={2}>
      <Grid item xs={6}>
        <InputSearching
          placeholder={getLabel("OBJ_INTERNAL_INPUT_SEARCH.search")}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <Search />
              </InputAdornment>
            ),
          }}
          defaultValue={filterTable?.filter}
          onSearch={handleChangeSearchValue}
        />
      </Grid>

      <Grid item xs={3}>
        <AppSelect
          label={getLabel("OBJ_INTERNAL_INPUT_SEARCH.reqSystem")}
          data={applicationList}
          value={filter?.applicationSendUid}
          onChange={handleChangeApplication}
        />
      </Grid>

      <Grid item xs={3}>
        <AppSelect
          label={getLabel("OBJ_INTERNAL_INPUT_SEARCH.reqStatus")}
          data={reqStatusList}
          value={filter?.status}
          onChange={handleChangeRequestStatus}
        />
      </Grid>

      <Grid item xs={3}>
        <InputDate
          label={getLabel("OBJ_INTERNAL_INPUT_SEARCH.fromDate")}
          format={AppConstant.FM_SHORT_DATE}
          onChange={handleChangeStartDate}
          maxDate={filterTable.endDate || undefined}
        />
      </Grid>

      <Grid item xs={3}>
        <InputDate
          label={getLabel("OBJ_INTERNAL_INPUT_SEARCH.toDate")}
          format={AppConstant.FM_SHORT_DATE}
          onChange={handleChangeEndDate}
          minDate={filterTable.startDate || undefined}
        />
      </Grid>
    </Grid>
  );
};

export default ResponseRequestFilter;
